<template>
  <div class="block-chain">
    <action-bar>
      <search v-model="inputContent" placeholder="请输入区块链ID" @onSearch="handleSearch"></search>
      <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
    </action-bar>
    <card-table
      :item-meta-title="metaTitle"
      :item-meta-data="metaData"
      :table-data="chainList"
      :paging="chainPaging"
      :operator="operator"
      :show-pagination="false"
      @pagination="handleSizeOrPageChange"
    >
    </card-table>
    <download-dialog
      :dialog-visible.sync="showDownloadDialog"
      title="下载部署包"
      :file-url="downloadUrl"
      :file-name="downloadFileName"
    ></download-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import auth from '@/auth/index'
export default {
  name: 'Index',
  components: {
  },
  data() {
    return {
      inputContent: '',
      btnList: [
        {
          btnContent: '新建区块链',
          click: () => {
            return this.createChain()
          },
          icon: 'icon-add',
          auth: auth.blockchain.addBlockChain
        },
        {
          btnContent: '订阅区块链',
          click: () => {
            return this.subscribeChain()
          },
          icon: 'icon-subscribe',
          auth: auth.blockchain.suscribeBlockChain
        }
      ],
      metaTitle: {
        label: '区块链ID',
        value: 'ChainId'
      },
      metaData: [
        { label: '智能合约', value: 'ContractNum', col: 15 },
        { label: 'ID', value: 'Id', col: 9 },
        { label: '区块高度', value: 'Height', col: 15 },
        {
          label: '组织数',
          value: 'OrgNum',
          col: 9,
          judgeShow: row => {
            //非公钥认证模式下，显示组织数
            return row.ChainMode != 'public'
          }
        },
        {
          label: '管理员数',
          value: 'AdminNum',
          col: 9,
          judgeShow: row => {
            //非公钥认证模式下，显示管理员
            return row.ChainMode == 'public'
          }
        },
        {
          label: '创建时间',
          value: 'CreateTime',
          col: 15,
          formatter: row => {
            return this.formatTime(row)
          }
        },
        { label: '节点数', value: 'NodeNum', col: 9 },
        { label: '区块链简介', value: 'Summary', col: 15 },
        {
          label: '状态',
          value: 'Healthy',
          col: 9,
          formatter: row => {
            return row.Healthy ? '已订阅': '未订阅'
          }
        },
        {
          label: '区块链来源',
          value: 'IsExternal',
          col: 24,
          formatter: row => {
            return row.IsExternal ? '平台外创建': '平台内创建'
          }
        }
      ],
      operator: [
        {
          text: '下载部署包',
          click: (row, col, cellValue) => {
            return this.downloadConfig(row)
          },
          icon: 'icon-download',
          auth: auth.blockchain.downloadDeployConfig
        },
        {
          text: '查看详情',
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          icon: 'icon-check',
          auth: auth.blockchain.checkDetail
        }
        /*{
          text: '申请加入',
          click: (row, col, cellValue) => {
            return this.applyJoin(row)
          },
          icon: 'icon-subscribe'
        },
        {
          text: '邀请',
          click: (row, col, cellValue) => {
            return this.invite(row)
          },
          icon: 'icon-invite'
        }*/
      ],
      searchChain: '',
      showDownloadDialog: false,
      downloadUrl: '',
      downloadFileName: ''
    }
  },
  computed: {
    ...mapState({
      chainList: state => state.chain.chain_list,
      chainPaging: state => state.chain.chain_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getBlockchainLists']),
    getList(limit = 9, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.searchChain,
        chainType: 'anytype' //''/'internal'返回内部链，'external'返回外部链，'anytype'返回内部链和外部链
      }
      this.getBlockchainLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleSearch(val) {
      this.searchChain = val
      this.getList()
    },
    createChain() {
      this.$router.push({
        name: 'addChain'
      })
    },
    subscribeChain() {
      this.$router.push({
        name: 'subscribeBlock'
      })
    },
    getInfo(row) {
      //DPOS共识算法不常用，可以创建部署即可，其链功能暂不开发
      if (row.Consensus == 'DPOS') {
        this.$message.info('DPoS共识链暂时不支持查看!')
      } else {
        this.$store.dispatch('updateActiveTab', 'overview')
        this.$router.push({
          name: 'chainDetail',
          query: {
            chainId: row.ChainId,
            detail: JSON.stringify(row)
          }
        })
        this.$store.commit('updateChainCid', row.ChainId)
      }
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd', row.CreateTime * 1000)
    },
    downloadConfig(row) {
      this.downloadUrl = `/cbaas-service/v1/chainManagement/downloadChain?chainId=${row.ChainId}`;
      this.downloadFileName = `${row.ChainId}_Package_部署包.zip`;
      this.showDownloadDialog = true
    }
  }
}
</script>

<style scoped lang="scss">

</style>
